<div class="z-[999] fixed inset-0 bg-black/50 backdrop-blur-xs flex items-center justify-center">
<div
  class="bg-white rounded-2xl flex px-4 flex-col overflow-hidden"
  [ngClass]="
    isLayoutStart
      ? 'w-[380px] xl:w-[430px] 2xl:w-[480px] 3xl:w-[580px]'
      : isLayoutA
        ? 'max-h-[90vh] w-[480px] xl:w-[540px] 2xl:w-[600px] 3xl:w-[680px]'
        : 'max-h-[90vh] w-[720px] 2xl:w-[900px] 3xl:w-[1080px]'
  "
>
    <!-- Header -->
    <div class="flex-none flex items-center justify-between pl-1 border-b border-gray-200">
      <h1 class="my-4 text-dimot-1 text-[0.88rem] xl:text-[0.93rem] 2xl:text-[1.01rem]">{{ modalTitle }}</h1>
      <button (click)="onCloseModal()">
        <svg
          class="mr-[7px] w-4 h-4 xl:w-5 xl:h-5 2xl:w-6 2xl:h-6 cursor-pointer"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.1471 18.3525C19.2024 18.404 19.2467 18.4661 19.2775 18.5351C19.3082 18.6041 19.3248 18.6786 19.3261 18.7541C19.3274 18.8296 19.3135 18.9047 19.2852 18.9747C19.2569 19.0447 19.2148 19.1084 19.1614 19.1618C19.108 19.2152 19.0444 19.2573 18.9743 19.2856C18.9043 19.3139 18.8293 19.3278 18.7537 19.3265C18.6782 19.3251 18.6037 19.3086 18.5347 19.2778C18.4657 19.2471 18.4036 19.2028 18.3521 19.1475L11.9996 12.7959L5.64714 19.1475C5.54051 19.2469 5.39947 19.301 5.25375 19.2984C5.10802 19.2958 4.96898 19.2368 4.86592 19.1337C4.76286 19.0307 4.70383 18.8916 4.70126 18.7459C4.69869 18.6002 4.75278 18.4591 4.85214 18.3525L11.2037 12L4.85214 5.64751C4.75278 5.54088 4.69869 5.39984 4.70126 5.25411C4.70383 5.10839 4.76286 4.96935 4.86592 4.86629C4.96898 4.76323 5.10802 4.7042 5.25375 4.70163C5.39947 4.69905 5.54051 4.75315 5.64714 4.85251L11.9996 11.2041L18.3521 4.85251C18.4588 4.75315 18.5998 4.69905 18.7455 4.70163C18.8913 4.7042 19.0303 4.76323 19.1334 4.86629C19.2364 4.96935 19.2955 5.10839 19.298 5.25411C19.3006 5.39984 19.2465 5.54088 19.1471 5.64751L12.7956 12L19.1471 18.3525Z"
            fill="#141F58"
          />
        </svg>
      </button>
    </div>

    <!-- LAYOUT START: singolo oggetto stepZero -->
    <ng-container *ngIf="isLayoutStart">
      <div class="flex-1 flex items-center justify-center px-6 py-8">
        <div class="w-full max-w-md">
          <table class="w-full table-fixed">
            <thead>
              <tr class="bg-tableHead h-[40px] xl:h-[45px] 2xl:h-[50px] text-[0.54rem] xl:text-[0.59rem] 2xl:text-[0.66rem] 3xl:text-[0.71rem] text-gray-700">
                <th class="w-[34%] text-start font-[MontserratBold] pl-4">LIVELLO</th>
                <th class="w-[33%] text-center font-[MontserratBold] text-dimot-2">FORECAST</th>
                <th class="w-[33%] text-center font-[MontserratBold] text-dimot-1">ACTUAL</th>
              </tr>
            </thead>
            <tbody>
              <tr class="h-10 xl:h-12 2xl:h-14 text-dimot-1 border-b border-gray-100">
                <td class="text-start pl-4 text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem]">Nazionale</td>
                <td class="text-center text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem] relative left-[2px]">{{ formatDate(data.stepZero.dueDate) }}</td>
                <td class="text-center">
                  <div class="flex justify-center relative left-[4px]">
                    <span
                      [ngClass]="getStatusClass(data.stepZero.status, data.stepZero.dueDate)"
                      class="text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem] font-medium me-2 px-2 py-0.5 rounded-sm inline-flex flex-col items-center"
                    >
                      {{ getStatusLabel(data.stepZero.status, data.stepZero.dueDate) }}
                      <span
                        *ngIf="data.stepZero.status === 'COMPLETED' && data.stepZero.endDate"
                        class="text-[0.52rem] xl:text-[0.56rem] 2xl:text-[0.6rem] 3xl:text-[0.64rem]"
                      >
                        {{ formatDate(data.stepZero.endDate) }}
                      </span>
                    </span>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </ng-container>

    <!-- LAYOUT A: Table for openToAccess, aggiudicazioneGara -->
    <ng-container *ngIf="isLayoutA">

      <!-- Fixed table header -->
      <div class="flex-none border-b border-gray-200">
        <table class="w-full table-fixed">
          <thead>
            <tr class="bg-tableHead h-[40px] xl:h-[45px] 2xl:h-[50px] text-[0.54rem] xl:text-[0.59rem] 2xl:text-[0.66rem] 3xl:text-[0.71rem] text-gray-700">
              <th class="w-[34%] text-start font-[MontserratBold] pl-4">REGIONE</th>
                <th class="w-[33%] text-center font-[MontserratBold] pr-[1px] text-dimot-2">FORECAST</th>
                <th class="w-[33%] text-center font-[MontserratBold] pr-4 text-dimot-1">ACTUAL</th>
            </tr>
          </thead>
        </table>
      </div>

      <!-- Scrollable body -->
      <div class="flex-1 overflow-y-auto scrollbar2 min-h-[280px] max-h-[520px] 3xl:max-h-[600px] mb-3">
        <table class="w-full table-fixed text-center">
          <colgroup>
            <col class="w-[34%]" />
            <col class="w-[33%]" />
            <col class="w-[33%]" />
          </colgroup>
          <tbody>
            <tr
              *ngFor="let row of tableRows"
              class="text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem] h-10 xl:h-12 2xl:h-14 text-dimot-1 border-b border-gray-100"
            >
              <td class="text-start pl-4">{{ row.regionName }}</td>
              <td>{{ formatDate(row.dueDate) }}</td>
              <td>
                <div class="flex justify-center">
                  <span
                    [ngClass]="getStatusClass(row.status, row.dueDate)"
                    class="font-medium me-2 px-2.5 py-0.5 rounded-sm inline-flex flex-col items-center"
                  >
                    {{ getStatusLabel(row.status, row.dueDate) }}
                    <span
                      *ngIf="row.status === 'COMPLETED' && row.endDate"
                      class="text-[0.52rem] xl:text-[0.56rem] 2xl:text-[0.6rem] 3xl:text-[0.64rem]"
                    >
                      {{ formatDate(row.endDate) }}
                    </span>
                  </span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </ng-container>

    <!-- LAYOUT B: Accordion for openToMarket -->
    <ng-container *ngIf="!isLayoutA && !isLayoutStart">
      <div class="flex-1 overflow-y-auto scrollbar2 min-h-[280px] max-h-[600px] px-4 pt-3 pb-4">

        <div
          *ngFor="let region of sortedOpenToMarket"
          class="mb-2 border border-gray-200 rounded-lg overflow-hidden"
        >
          <!-- Region accordion trigger -->
          <button
            (click)="toggleRegion(region.regionId)"
            class="w-full flex items-center justify-between px-4 py-3 bg-gray-50 hover:bg-gray-100 transition-colors duration-150 text-dimot-1 text-[0.64rem] xl:text-[0.72rem] 2xl:text-[0.82rem] font-semibold cursor-pointer"
          >
            <span>{{ region.regionName }}</span> 
            <svg
              [class.rotate-180]="isRegionExpanded(region.regionId)"
              class="w-4 h-4 transition-transform duration-200"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          <!-- Hospital rows (accordion body) -->
          <div *ngIf="isRegionExpanded(region.regionId)">
            <table class="w-full table-fixed">
              <thead>
                <tr class="bg-tableHead h-[40px] xl:h-[45px] 2xl:h-[50px] text-[0.54rem] xl:text-[0.59rem] 2xl:text-[0.66rem] 3xl:text-[0.71rem] text-gray-700">
                  <th class="w-[40%] text-start font-[MontserratBold] pl-8">OSPEDALE</th>
                <th class="w-[33%] text-center font-[MontserratBold] pr-[1px] text-dimot-2">FORECAST</th>
                <th class="w-[33%] text-center font-[MontserratBold] pr-4 text-dimot-1">ACTUAL</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="let hospital of region.hospitals"
                  class="h-10 xl:h-12 2xl:h-14 text-dimot-1 border-b border-gray-100"
                >
                  <td class="text-start pl-8 text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem]">{{ hospital.name | hospitalTitlecase }} - {{hospital.city}}</td>
                  <td class="text-center text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem]">{{ formatDate(hospital.dueDate) }}</td>
                  <td class="text-center">
                    <div class="flex justify-center">
                      <span
                        [ngClass]="getStatusClass(hospital.status, hospital.dueDate)"
                        class="text-[0.57rem] xl:text-[0.64rem] 2xl:text-[0.69rem] 3xl:text-[0.74rem] font-medium me-2 px-2.5 py-0.5 rounded-sm inline-flex flex-col items-center"
                      >
                        {{ getStatusLabel(hospital.status, hospital.dueDate) }}
                        <span
                          *ngIf="hospital.status === 'COMPLETED' && hospital.endDate"
                          class="text-[0.52rem] xl:text-[0.56rem] 2xl:text-[0.6rem] 3xl:text-[0.64rem]"
                        >
                          {{ formatDate(hospital.endDate) }}
                        </span>
                      </span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>

      </div>
    </ng-container>

  </div>
</div>